import { render, staticRenderFns } from "./ShorexEnhanceTag.vue?vue&type=template&id=1fb87034&scoped=true"
import script from "./ShorexEnhanceTag.vue?vue&type=script&lang=js"
export * from "./ShorexEnhanceTag.vue?vue&type=script&lang=js"
import style0 from "./ShorexEnhanceTag.vue?vue&type=style&index=0&id=1fb87034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb87034",
  null
  
)

export default component.exports